import { useCallback } from 'react';

import type {
  SwitchWorkspaceOptions,
} from '@/contexts/account/types/execute-workspace-switch-types';
import {
  WorkspaceSwitchResult,
} from '@/contexts/account/types/workspace-switch-outcome-types';

import { useAccountActions, useAccountMeta } from '@/contexts/account/account-context';
import {
  UseWorkspaceSwitchReturn,
} from '../types/use-workspace-switch-types';


export function useWorkspaceSwitch(): UseWorkspaceSwitchReturn {
  const { switchWorkspace: contextSwitchWorkspace } = useAccountActions();
  const { isTransitioning } = useAccountMeta();

  const switchWorkspace = useCallback(
    (
      targetWorkspaceId: string,
      options?: SwitchWorkspaceOptions
    ): Promise<WorkspaceSwitchResult> =>
      contextSwitchWorkspace(targetWorkspaceId, options),
    [contextSwitchWorkspace]
  );

  return {
    switchWorkspace,
    isSwitching: isTransitioning,
  };
}
